export class Environement {
  static envIsDev = import.meta.env.DEV;

  static defaultEditMode: boolean = this.envIsDev;
}
